import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
const CustomerContact = (props: any) => {
  const { contactData, label, handleUpdateContact, branch, city } = props;
  const {
    setError,
    formState: { errors },
  } = useForm<any>({});

  return (
    <div
      className={tw`relative flex flex-col min-w-0 break-words bg-white w-full`}
    >
      <div className={tw`block w-full overflow-x-auto`}>
        <table
          className={tw`tems-center bg-transparent w-full border-collapse `}
        >
          <thead>
            <tr>
              <th
                className={tw`px-6  bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left`}
              >
                {label}
              </th>
              <th
                className={tw`px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left`}
              >
                Name
              </th>
              <th
                className={tw`px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left`}
              >
                Address
              </th>
              <th
                className={tw`px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left`}
              >
                VAT_PAN
              </th>
              <th
                className={tw`px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left`}
              >
                Contact
              </th>
              {/* <th className="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                Alt Contact
              </th> */}
            </tr>
          </thead>
          <tbody>
            {contactData?.map((item: any, index: number) => (
              <tr key={index} className={tw`even:bg-gray-50 odd:bg-white`}>
                <th
                  className={tw`border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap text-left text-blueGray-700 `}
                >
                  {item?.destination?.name}
                </th>
                <td
                  className={tw`border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap `}
                >
                  <input
                    type="text"
                    defaultValue={item?.name}
                    className={tw`w-full p-1 outline-none bg-transparent `}
                    onBlur={(e: any) =>
                      handleUpdateContact(
                        item?.contact,
                        item?.destination.id,
                        branch,
                        city,
                        item?.address,
                        e.target.value,
                        item?.vat_pan,
                        setError
                      )
                    }
                  />
                  {errors?.name && (
                    <p className={tw`text-red-500 text-xs my-1`}>
                      {errors?.name?.message}
                    </p>
                  )}
                </td>
                <td
                  className={tw`border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap `}
                >
                  <input
                    type="text"
                    defaultValue={item?.address}
                    className={tw`w-full p-1 outline-none bg-transparent `}
                    onBlur={(e: any) =>
                      handleUpdateContact(
                        item?.contact,
                        item?.destination.id,
                        branch,
                        city,
                        e.target.value,
                        item?.name,
                        item?.vat_pan,
                        setError
                      )
                    }
                  />
                  {errors?.address && (
                    <p className={tw`text-red-500 text-xs my-1`}>
                      {errors?.address?.message}
                    </p>
                  )}
                </td>
                <td
                  className={tw`border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap `}
                >
                  <input
                    type="text"
                    defaultValue={item?.vat_pan}
                    className={tw`w-full p-1 outline-none bg-transparent `}
                    onBlur={(e: any) =>
                      handleUpdateContact(
                        item?.contact,
                        item?.destination.id,
                        branch,
                        city,
                        item?.address,
                        item?.name,
                        e.target.value,
                        setError
                      )
                    }
                  />
                  {errors?.vat_pan && (
                    <p className={tw`text-red-500 text-xs my-1`}>
                      {errors?.vat_pan?.message}
                    </p>
                  )}
                </td>
                <td
                  className={tw`border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap `}
                >
                  <input
                    type="text"
                    defaultValue={item?.contact}
                    className={tw`w-full p-1 outline-none bg-transparent `}
                    onBlur={(e: any) =>
                      handleUpdateContact(
                        e.target.value,
                        item?.destination.id,
                        branch,
                        city,
                        item?.address,
                        item?.name,
                        item?.vat_pan,
                        setError
                      )
                    }
                  />
                  {errors?.contact && (
                    <p className={tw`text-red-500 text-xs my-1`}>
                      {errors?.contact?.message}
                    </p>
                  )}
                </td>
                {/* <td className="border-t-0 px-6 align-center border-l-0 border-r-0 text-xs whitespace-nowrap">
                  <input type="text" className='w-full p-1 outline-none bg-transparent ' />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerContact;
